import useGuestShoppingListMerge from '~/composables/useGuestShoppingListMerge';

export default defineNuxtPlugin(() => {
	useGuestShoppingListMerge();
});
